import { ThemeInput } from "./tokens";

export default {
  dark: false,
  colors: {
    "primary": "#AC3D44",
    "on-primary": "#ffffff",
    "secondary": "#AC3D44",
    "on-secondary": "#ffffff",
    "error": "#FF5252",
    "on-error": "#ffffff",
    "background": "#ffffff",
    "on-background": "#000000",
    "surface": "#eeeeee",
    "on-surface": "#494949",
    "info": "#2196F3",
    "on-info": "#ffffff",
    "success": "#4CAF50",
    "on-success": "#ffffff",
    "warning": "#FB8C00",
    "on-warning": "#ffffff",
    // Custom colors
    "dark-background": "#B4272D",
    "on-dark-background": "#ffffff",
    "content-background": "#F8F8F8",
    "on-content-background": "#000000",
    "stripes-background": "#AC3D44",
    "on-stripes-background": "#ffffff",
  },
  variables: {},
} satisfies ThemeInput;
